import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import BlogLayout from './BlogLayout';
import Seo from '../components/Seo';
import { getPostBySlug, formatPostDate } from '../utils/blog';

export default function BlogPostPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: 'loading', post: null });

  useEffect(() => {
    window.scrollTo(0, 0);
    let active = true;
    getPostBySlug(slug).then((post) => {
      if (!active) return;
      setState({ status: post ? 'ready' : 'missing', post });
    });
    return () => {
      active = false;
    };
  }, [slug]);

  if (state.status === 'loading') {
    return (
      <BlogLayout>
        <main className="blog-post" />
      </BlogLayout>
    );
  }

  if (state.status === 'missing') {
    return (
      <BlogLayout>
        <Seo title="Post Not Found — Sovrynn" />
        <main className="blog-post">
          <p className="blog-post__meta">Post not found</p>
          <h1 className="blog-post__title">Nothing here yet.</h1>
          <Link to="/blog" className="blog-post__back">
            ← Back to all posts
          </Link>
        </main>
      </BlogLayout>
    );
  }

  const { post } = state;

  return (
    <BlogLayout>
      <Seo
        title={post.title ? `${post.title} — Sovrynn` : 'Blog — Sovrynn'}
        description={post.excerpt}
      />
      <main className="blog-post">
        <article aria-labelledby="blog-post-h">
          <header className="blog-post__head">
            <Link to="/blog" className="blog-post__back">
              ← All posts
            </Link>
            <div className="blog-post__meta">
              {post.date ? <span>{formatPostDate(post.date)}</span> : null}
              {post.date && post.readTime ? (
                <span className="blog-post__meta-sep" aria-hidden>
                  ·
                </span>
              ) : null}
              {post.readTime ? <span>{post.readTime}</span> : null}
            </div>
            <h1 id="blog-post-h" className="blog-post__title">
              {post.title || 'Untitled'}
            </h1>
            <div className="blog-trails" aria-hidden>
              <div className="lp-trail" style={{ width: 100 }} />
              <div className="lp-trail lp-trail--dim" style={{ width: 64 }} />
            </div>
          </header>

          <div className="blog-post__body">
            <ReactMarkdown>{post.body}</ReactMarkdown>
          </div>
        </article>
      </main>
    </BlogLayout>
  );
}
